import { capitalizeFirstLetter, getCurrentDateEnUsFormat } from '../lib/utils'
import PDF from './pdf'

export default class OverallInventory extends PDF {
  /**
   * Description
   * @param {import('jspdf').DocumentProperties} args
   */
  constructor(args = {}) {
    super()
    this.doc.setProperties({
      unit: 'mm',
      format: 'a4',
      ...args,
    })
    this.addFonts()
  }

  /**
   * Description
   * @param {boolean} [cancel]
   */
  __header(dateRange) {
    const title = `${capitalizeFirstLetter(this.getStoreName())} Inventory Report`
    this.centerText({ fontSize: 24, text: title, color: [55, 71, 79] })
    this.centerText({ fontSize: 12, text: dateRange, yOffset: 15 })
    this.doc.setFillColor('#CFD8DC')
    this.doc.line(15, 25, 195, 25, 'F')
  }

  /**
   * Description
   * @param {InventoryItem[]} body
   */
  __table(body) {
    this.doc.autoTable({
      head: [['Item', 'In', 'Out', 'Remain', 'Unit', 'Worth']],
      startY: 30,
      columnStyles: {
        amount: { halign: 'right' },
        paidAmount: { halign: 'right' },
        unpaidAmount: { halign: 'right' },
        noOfItems: { halign: 'center' },
      },
      body: [
        ...body,
      ],
    })
  }

  /**
   * Description
   * @param {string} receiptNo
   * @param {boolean} [cancel]=false
   * @returns {void}
   */
  __save() {
    const name = `${this.getStoreName()}_overall_inventory_${this.getStoreName()}_${new Date().getTime()}`
    this.doc.save(name)
  }

  /**
   * Description
   * @param {SummaryData} data
   * @param {SummaryItem[]} items
   * @param {boolean} [cancel]
   * @returns {any}
   */
  generate(items, dateRange) {
    this.__header(dateRange)
    this.__table(items)
    this.__save()
  }
}

/**
 * @typedef {[string,string,number,number,number,string,string]} InventoryItem
 */
